import { Show } from "solid-js";

import NotFound from "~/components/NotFound";
import UnknownError from "~/components/UnknownError";

interface HandleErrorProps {
  readonly error: any;
  readonly reset: () => void;
}

export default function HandleError(props: HandleErrorProps) {
  console.error(props.error);

  return (
    <Show
      when={props.error.statusCode === 404}
      fallback={
        <UnknownError code={props.error.statusCode} reset={props.reset} />
      }
    >
      <NotFound />
    </Show>
  );
}
